// src/components/Container.jsx
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

const Styled = styled.div`
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  /* 좌우 패딩 (노치 대응) — noPadding이면 0 */
  padding-left: ${({ $noPadding }) =>
        $noPadding ? "0" : "max(16px, env(safe-area-inset-left))"};
  padding-right: ${({ $noPadding }) =>
        $noPadding ? "0" : "max(16px, env(safe-area-inset-right))"};

  /* 슬라이더/이미지의 1~2px 넘침 방지 */
  overflow-x: hidden;

  /* noMax가 아닐 때만 max-width 적용 */
  ${({ $noMax, $max }) =>
        !$noMax &&
        css`
      max-width: ${$max}px;
    `}

  /* full이면 무조건 100% (noMax와 동일 효과) */
  ${({ $full }) =>
        $full &&
        css`
      max-width: 100%;
    `}
`;

/**
 * Props
 * - max: 기본 720
 * - full: true면 100% (max 제한 해제와 동일)
 * - noPadding | nopadding: 좌우 패딩 제거
 * - noMax | nomax: max-width 제거 (width:100% 유지)
 */
export function Container(props) {
    const {
        children,
        max = 720,
        full = false,
        noPadding = false,
        nopadding, // alias 지원
        noMax = false,
        nomax, // alias 지원
        ...rest
    } = props;

    const _noPadding = noPadding || nopadding || false;
    const _noMax = full || noMax || nomax || false; // full이면 사실상 noMax

    const [vw, setVw] = useState(
        typeof window !== "undefined" ? window.innerWidth : max
    );

    useEffect(() => {
        const onResize = () => setVw(window.innerWidth);
        window.addEventListener("resize", onResize, { passive: true });
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // full/noMax면 계산 불필요
    const computedMax = _noMax ? vw : Math.min(vw, max);

    return (
        <Styled
            $max={computedMax}
            $full={!!full}
            $noPadding={_noPadding}
            $noMax={_noMax}
            {...rest}
        >
            {children}
        </Styled>
    );
}

export default Container;
